import Heading from "../../../Components/Heading/Heading";
import AddGovernment from "./AddGovernment";
import TableRegionSettings from "./TableRegionSettings";

function RegionSettings() {
  return (
    <>
      <Heading heading="إعدادت المناطق" />
      <AddGovernment />
      <TableRegionSettings />
    </>
  );
}

export default RegionSettings;
